module.exports = __webpack_public_path__ + "static/img/hanssem.bca0d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hanssem.jpg
// module id = pzB3
// module chunks = 0